// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1Sikf","chevron":"styles_chevron__njzUk","headerText":"styles_headerText__2eWVF","content":"styles_content__2RuaC","separator":"styles_separator__3Ms6X"};